<template>
    <div class="klepto-builder">
        <h3>welcome to the builder human</h3>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    export default {
        components: {

        },
        mixins: [

        ],
        data() {
            return {

            }
        },
        computed: {
            ...mapGetters('gameOS', {

            }),
        },
        methods: {
            ...mapActions('gameOS', [

            ]),
        }
    }
</script>

<style lang="scss" scoped>

    //------------------------------------------------------
    //
    //------------------------------------------------------
</style>